import { createFileRoute, useParams } from "@tanstack/react-router";
import { Receipt } from "lucide-react";
import FactureView from "@/features/ventes/components/facturation/FactureView";

function FactureVentesViewPage() {
  const { id } = useParams({ from: Route.id });
  return <FactureView id={id} />;
}

export const Route = createFileRoute("/_app/comptabilite/factures-ventes/$id/view")({
  staticData: {
    title: "Détails Facture",
    icon: Receipt,
    showInBreadcrumb: true,
  },
  component: FactureVentesViewPage,
});
